import { RoomAudioRenderer, RoomContext } from '@livekit/components-react';
import { Room } from 'livekit-client';

type Props = {
  children: React.ReactNode;
  room: Room | null;
  shouldRenderAudio?: boolean;
};

export default function LivekitRoomGateProvider({
  children,
  room,
  shouldRenderAudio = false,
}: Props) {
  if (room?.state === 'disconnected' || !room) {
    return children;
  }

  return (
    <RoomContext.Provider value={room}>
      {shouldRenderAudio && <RoomAudioRenderer volume={1.0} />}
      {children}
    </RoomContext.Provider>
  );
}
